import { Link } from "react-router-dom";
import { adminProcApi } from "../../api";
import { ProcError, ProcLoading, ProcPagination } from "../../components/ProcurementLayout";
import { useAsyncData, usePageState } from "../../hooks";

export default function TenderListPage() {
  const { page, size, setPage, state } = usePageState();

  const { data, loading, error } = useAsyncData(
    () => adminProcApi.listTenders({ page: state.page, size: state.size }),
    [state.page, state.size],
  );

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Tender Opening Register</h1>
        </div>
        <Link to="/procurement/admin/tenders/new" className="rounded-xl bg-emerald-700 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-800">
          New Entry
        </Link>
      </div>

      {loading && <ProcLoading />}
      {error && <ProcError message={error} />}

      {!loading && !error && data && (
        <>
          <div className="rounded-2xl border bg-white shadow-sm overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase text-slate-500">
                <tr>
                  <th className="px-4 py-3">Serial No</th>
                  <th className="px-4 py-3">Tender / RFQ No</th>
                  <th className="px-4 py-3">Supplier</th>
                  <th className="px-4 py-3">Date Received</th>
                  <th className="px-4 py-3">Time</th>
                  <th className="px-4 py-3">Remarks</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {data.content.length === 0 && (
                  <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-400">No tender entries found.</td></tr>
                )}
                {data.content.map((r) => (
                  <tr key={r.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3 font-mono font-semibold text-slate-900">{r.serialNo}</td>
                    <td className="px-4 py-3 font-semibold text-slate-800">{r.tenderRfqNo}</td>
                    <td className="px-4 py-3 text-slate-600">{r.supplierName}</td>
                    <td className="px-4 py-3 text-slate-600">{r.dateReceived ? new Date(r.dateReceived).toLocaleDateString() : "—"}</td>
                    <td className="px-4 py-3 text-slate-600">{r.timeReceived || "—"}</td>
                    <td className="px-4 py-3 text-slate-500 max-w-xs truncate">{r.remarks || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ProcPagination
            page={data.number}
            totalPages={data.totalPages}
            totalElements={data.totalElements}
            onPage={setPage}
          />
        </>
      )}
    </div>
  );
}
